import React from "react";

import { Container, Sufix } from "./styles";

function Input({
  id,
  label,
  placeholder,
  mensagemErro,
  value,
  handler,
  required,
}) {
  return (
    <Container>
      <label>{label}</label>
      <Sufix>
        <input
          id={id}
          type="number"
          step="0.01"
          placeholder={placeholder}
          value={value}
          onChange={handler}
          required={required}
        />
      </Sufix>
      <span>{mensagemErro}</span>
    </Container>
  );
}

export default Input;
